import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { map, takeUntil } from 'rxjs/operators';
import {
	CommunicationEvents,
	CurrenciesDetails,
	SubscriptionCategory,
	SubscriptionChoosePlan,
	SubscriptionPlan,
	SubscriptionPlanResponse
} from '@models/subscription.model';
import { NewSubscriptionServiceDataProvider } from '@services/subscription/subscription.service';
import { IframeService } from '@services/helpers/iframe-service/iframe.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionList } from '@models/models';

@Component({
	selector: 'subscription-modal',
	template: require('./subscription-modal.html'),
	styles: [require('./subscription-modal.scss')]
})
export class SubscriptionModalComponent implements OnInit {
	@Input() urlToLoad: string;

	categories: SubscriptionCategory;
	categoriesLength: number;
	selectedCategory: Array<SubscriptionPlan> = [];
	categoriesNames: Array<string> = [];
	modalTitle: string;
	priceExplanation: string;
	showModalContent: boolean;
	modalActions: ActionList;
	currencies: Array<CurrenciesDetails> = [];
	selectedCurrency: CurrenciesDetails;
	selectedCurrencyUrl: string | undefined;
	activeIndex = 0;

	private iframeOpenEvent;
	private iframeCloseEvent;
	private unsubscribe: Subject<any> = new Subject();

	constructor(
		private subscriptionService: NewSubscriptionServiceDataProvider,
		private renderer: Renderer2,
		private iframeService: IframeService,
		private activeModal: NgbActiveModal
	) {}

	ngOnInit(): void {
		this.getCachedCurrency();
		this.fetchSubscriptionPlans();
		this.onCheckoutPlanModalIframeOpen();
		this.onCheckoutPlanModalIframeClose();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	closeModal(): void {
		this.clearCurrencyCache();
		this.clearUrlCache();
		this.subscriptionService.setChoosePlanOpenModalStatus({
			state: false,
			payload: null
		});
		this.activeModal.dismiss();
	}

	changeSelectedCategory([category, index]: [string, number]): void {
		this.changeActiveCategory(category);
		this.activeIndex = index;
	}

	selectPlan(plan: SubscriptionPlan): void {
		this.iframeService.setUrlIframe(plan.actions.SELECT_PLAN.url);
	}

	private changeActiveCategory(category: string): void {
		this.selectedCategory = this.categories[category];
	}
	private fetchSubscriptionPlans(): void {
		this.subscriptionService
			.getSubscriptions(this.urlToLoad, this.selectedCurrencyUrl)
			.pipe(
				takeUntil(this.unsubscribe),
				map(
					(data: SubscriptionPlanResponse): SubscriptionChoosePlan => data.data
				)
			)
			.subscribe((data: SubscriptionChoosePlan): void =>
				this.successGetSubscriptionPlans(data)
			);
	}

	private successGetSubscriptionPlans(data: SubscriptionChoosePlan): void {
		const categories = Object.keys(data.category);
		this.currencies = data.currencies;
		if (this.currencies) {
			const [selectedCurrency] = this.currencies.filter(
				(currency: CurrenciesDetails): CurrenciesDetails => {
					if (currency.selected) {
						return currency;
					}
				}
			);
			this.selectedCurrency = selectedCurrency;
		}
		this.categories = data.category;
		this.categoriesLength = categories.length;
		this.selectedCategory = this.categories[Object.keys(this.categories)[0]];
		this.categoriesNames = categories;
		this.modalTitle = data.title;
		this.priceExplanation = data.priceComment;
		this.modalActions = data.actions;
		this.showModal();
	}

	chooseCurrency(event: CurrenciesDetails): void {
		this.cacheCurrency(event);
		this.selectedCurrency = event;
		this.selectedCurrencyUrl = this.selectedCurrency.currencyType;
		this.activeIndex = 0;
		this.fetchSubscriptionPlans();
	}

	private getCachedCurrency(): void {
		const currency = sessionStorage.getItem('cachedCurrency');

		if (currency) {
			this.selectedCurrency = JSON.parse(currency);
			this.selectedCurrencyUrl = this.selectedCurrency.currencyType;
		}
	}

	private cacheCurrency(currency: CurrenciesDetails): void {
		sessionStorage.setItem('cachedCurrency', JSON.stringify(currency));
	}

	private clearCurrencyCache(): void {
		sessionStorage.removeItem('cachedCurrency');
	}

	private clearUrlCache(): void {
		sessionStorage.removeItem('cachedUrl');
	}

	private showModal(): void {
		this.showModalContent = true;
	}

	private unsubscribeIframeEvents(): void {
		this.iframeOpenEvent();
		this.iframeCloseEvent();
	}

	private onCheckoutPlanModalIframeOpen(): void {
		this.iframeOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.planCheckoutOpen,
			(): void => {}
		);
	}

	private onCheckoutPlanModalIframeClose(): void {
		this.iframeCloseEvent = this.renderer.listen(
			'document',
			CommunicationEvents.planCheckoutClose,
			(): void => {
				this.unsubscribeIframeEvents();
				this.iframeService.setUrlIframe(null);
			}
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/subscription/modals/subscription-modal/subscription-modal.ts